import { APP_CONFIG } from '../config';

export const BASE_PATH = APP_CONFIG.publicUrl ?? '/';
export const LOGIN_PAGE = 'login';
export const ADMIN_PAGE = 'admin';
export const MIETER_PLUS_PATH = 'mieterplus';
export const WOHNEN_PLUS_PATH = 'wohnenplus';
export const KAEUFER_PLUS_PATH = 'kaeuferplus';
export const BASE_PLUS = KAEUFER_PLUS_PATH;
export const FINO_PATH = 'fino';

//  common plus benefit routes
export const MAGENTA_TV = 'magenta-tv';

// MIETER_PLUS_PATH routes
export const WELCOME_MODAL = 'willkommen';
export const MIETER_NETZWERK = 'mieter-netzwerk';
export const WARTELISTE = 'warteliste';

export const CHANCEN_CHECK = 'chancen-check';
export const EXKLUSIVE_ANZEIGEN = 'exklusive-anzeigen';
export const OBEN_IM_POSTFACH = 'oben-im-postfach';
export const SCHUFA = 'schufa';
export const BEWERBERMAPPE = 'bewerbermappe';
export const BESICHTIGUNGSKALENDER = 'besichtigungskalender';
export const MIETKAUTIONSBURGSCHAFT = 'mietkautionsburgschaft';
export const UMZUGSSERVICE = 'umzugsservice';
export const ADRESSWECHSEL = 'adresswechsel';
// WOHNEN_PLUS_PATH routes
/**
 * @deprecated This constant is deprecated and should not be used.
 * Replaced AXA with ARAG.
 */
export const MIETRECHTSBERATUNG = 'mietrechtsberatung';
/**
 * @deprecated This constant is deprecated and should not be used.
 * Replaced AXA with ARAG.
 */
export const SCHLUSSELDIENST = 'schlusseldienst';
export const RECHTSBERATUNG = 'rechtsberatung';
export const SCHLUESSELDIENST = 'schluesseldienst';
export const MIETRECHTSSCHUTZ = 'mietrechtsschutz';
export const MEDIATION = 'mediation';
export const NEBENKOSTEN_CHECK = 'nebenkosten-check';
export const LAGERRAUM = 'lagerraum';
export const UMZUGSKISTEN = 'umzugskisten';
export const MIETERSCHUTZ = 'mieterschutz';
export const GREEN_ELECTRICITY = 'green-electricity';
export const WOHNEN_PLUS_LIGHT = 'wohnen-plus-light';

// KAEUFER_PLUS_PATH routes
export const VORSTELLUNGSMAPPE = 'vorstellungsmappe';
export const IMMOBILIENBEWERTUNG = 'immobilienbewertung';
export const DERKA_IMMOBILIENBEWERTUNG = 'derka-immobilienbewertung';
export const DEKRA_BAUSCHADENGUTACHTEN = 'derka-auschadengutachten';
export const NACHBARSCHAFTS = 'nachbarschafts';
export const FINANZIERUNGSMANAGER = 'finanzierungsManager';

// BillcheckV3 form routes
export const CUSTOMER_DETAILS = 'customer-details';
export const BALANCE_DETAILS = 'balance-details';
export const ACCOUNTING_PERIOD_DETAILS = 'accounting-period-details';
export const OPERATIONAL_STATEMENT_UPLOAD = 'operational-statement-upload';
export const RENTAL_CONTRACT_UPLOAD = 'rental-contract-upload';
export const ERROR = 'error';

export const BILLCHECK_FLOW_STEPS = [
  CUSTOMER_DETAILS,
  BALANCE_DETAILS,
  ACCOUNTING_PERIOD_DETAILS,
  OPERATIONAL_STATEMENT_UPLOAD,
  RENTAL_CONTRACT_UPLOAD,
];
